import { render } from "./NDraw.vue?vue&type=template&id=2337e40e&ts=true"
import script from "./NDraw.vue?vue&type=script&lang=ts"
export * from "./NDraw.vue?vue&type=script&lang=ts"

import "./NDraw.vue?vue&type=style&index=0&id=2337e40e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__